// extracted by mini-css-extract-plugin
module.exports = {"container":"DisclaimersButton_container__2KMBA","button":"DisclaimersButton_button__Rw6nC"};